// extracted by mini-css-extract-plugin
module.exports = {"contentBox":"ih","contentFrame":"ii","buttonGroup":"ij","button":"ik","header":"il","text":"im","contentImage":"in"};